import type { AccountCapacity } from "@woven/contracts";
import { createContext, useContext } from "react";

export type CapacityState =
  { status: "loading" } | { status: "ready"; data: AccountCapacity } | { status: "error" };

export const AccountCapacityContext = createContext<{
  state: CapacityState;
  refresh: () => void;
} | null>(null);

export function useAccountCapacity() {
  const context = useContext(AccountCapacityContext);
  if (!context) throw new Error("useAccountCapacity must be used within AccountCapacityProvider");
  return context;
}
